import React, {  useState } from 'react';
import {  Button,  } from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import {  submitPurchase } from '../../../services/RodtepReportService';
import { Form } from 'react-bootstrap';
import { Modal } from 'antd';
import isEmpty from 'lodash/isEmpty'

const PurchaseModal = (props) => {
    const [formValues, setFormValues] = useState({
      scrip_number: '',
      scrip_issue_date: '',
      scrip_expiry_date: '',
      scrip_issue_amount: 0,
      scrip_balance_amount: 0,
      trading_details: '',
      rate: 0,
    });
  
  
  
    const handleInputChange = (e) => {
      const { name, value, type } = e.target;
      if (name === 'scrip_issue_amount' || name === 'scrip_balance_amount' || name === 'rate') {
        setFormValues({
          ...formValues,
          [name]: parseFloat(value),
        });
      } else if( type === 'date') {
        setFormValues({
          ...formValues,
          [name]: formatDateTime(value),
        });
      }
      else{
        setFormValues({
          ...formValues,
          [name]: value,
        });
      }
  
    }
  
    const closeModal = () => {
      setFormValues({
        scrip_number: null,
        scrip_issue_date: null,
        scrip_expiry_date: null,
        scrip_issue_amount: 0,
        scrip_balance_amount: 0,
        trading_details: '',
        rate: 0
  
      });
      props?.handleClose() && props?.handleClose();
  
    };
  
    function validateScripObject(scrip) {
      const errors = {};
  
      if (isEmpty(scrip.scrip_number)) {
          errors.scrip_number = "Scrip number is required.";
      }
      if (isEmpty(scrip.scrip_issue_date)) {
          errors.scrip_issue_date = "Scrip issue date is required.";
      }
      if (isEmpty(scrip.scrip_expiry_date)) {
          errors.scrip_expiry_date = "Scrip expiry date is required.";
      }
      if (isEmpty(scrip.trading_details)) {
        errors.scrip_expiry_date = "Trading Details is required.";
      }
  
      if (scrip.scrip_issue_date && scrip.scrip_expiry_date) {
          const issueDate = new Date(scrip.scrip_issue_date);
          const expiryDate = new Date(scrip.scrip_expiry_date);
  
          if (isNaN(issueDate.getTime())) {
              errors.scrip_issue_date = "Invalid issue date format.";
          }
          if (isNaN(expiryDate.getTime())) {
              errors.scrip_expiry_date = "Invalid expiry date format.";
          }
          if (!errors.scrip_issue_date && !errors.scrip_expiry_date && expiryDate <= issueDate) {
              errors.scrip_expiry_date = "Scrip expiry date should be greater than the issue date.";
          }
      }
  
      if (typeof scrip.scrip_issue_amount !== "number" || scrip.scrip_issue_amount < 0) {
          errors.scrip_issue_amount = "Scrip issue amount must be a non-negative number.";
      }
      if (typeof scrip.scrip_balance_amount !== "number" || scrip.scrip_balance_amount < 0) {
          errors.scrip_balance_amount = "Scrip balance amount must be a non-negative number.";
      }
      if (scrip.scrip_balance_amount > scrip.scrip_issue_amount) {
        errors.scrip_balance_amount = "Scrip balance amount must be less than or equal to issue amount.";
      }

      if (typeof scrip.rate !== "number") {
        errors.rate = "Rate value must be a number";
      }
      
      if (scrip.rate > 100) {
        errors.rate = "Rate value must be less than or equals to 100";
      }
  
      return Object.keys(errors).length === 0 ? null : errors;
  }
  
  
  
    const onSubmit = async () => {
  
      try {
        const errors = validateScripObject(formValues)
        if (!isEmpty(errors)) {
          throw new Error(Object.values(errors).join(','))
        }
        const formData = { ...formValues, trading_type: 'PURCHASE' }
        // Append any additional data or files if needed
        // Make the API call
        await submitPurchase(formData)
        closeModal()
        props.onSuccessFunction("New Scrip purchase created successfully!")
  
      }
      catch (error) {
        errorFunction(error?.message ? error?.message : error);
      }
  
    };
  
    const errorFunction = (content) => {
      if (props?.errorFunction) {
        props.errorFunction(content)
      }
    };
  
  
    const formatDateTime = (dateTimeStr) => {
      const date = new Date(dateTimeStr);
      if (isNaN(date.getTime())) {
          return null;
      }
      return date.toISOString().split('T')[0];
  }
  
  
  
    return (
      <div id="test-modal">
        <Modal
          title={props.title}
          width={"60%"}
          open={props.open}
          onCancel={closeModal}
          footer={[
            <Button key="submit" type="primary" className="cip-btn-submit" onClick={onSubmit}>
              Submit
            </Button>
          ]}
        >
          <Card>
            <Card.Body>
              <hr className="hr-horizontal" />
              <Form>
                <Form.Group as={Row} className="mb-3" controlId="scrip_number">
                  <Form.Label column sm="2">Scrip Number*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="text"
                      name="scrip_number"
                      placeholder='Enter Scrip Number'
                      value={formValues.scrip_number}
                      onChange={handleInputChange}
                    />
                  </Col>
                  <Form.Label column sm="2">Trading Details*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      name="trading_details"
                      placeholder='Enter Trading Details: importer/exporter name, iec, etc.'
                      value={formValues.trading_details}
                      onChange={handleInputChange}
                      type="text"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="scrip_issue_date">
                  <Form.Label column sm="2">Scrip Issue Date*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="date"
                      name="scrip_issue_date"
                      placeholder='Enter Scrip Issue Date'
                      value={formValues.scrip_issue_date}
                      onChange={handleInputChange}
                    />
                  </Col>
                  <Form.Label column sm="2">Scrip Expiry Date*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="date"
                      name="scrip_expiry_date"
                      defaultValue={formValues.scrip_issue_date}
                      placeholder='Enter Scrip Expiry Date'
                      value={formValues.scrip_expiry_date}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="scrip_issue_amount">
                  <Form.Label column sm="2">Scrip Issue Amount*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="number"
                      name="scrip_issue_amount"
                      placeholder='Enter Scrip Issue Amount'
                      value={formValues.scrip_issue_amount}
                      onChange={handleInputChange}
                    />
                  </Col>
                  <Form.Label column sm="2">Scrip Balance Amount*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="number"
                      name="scrip_balance_amount"
                      placeholder='Enter Scrip Balance Amount'
                      value={formValues.scrip_balance_amount}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Form.Group>  
                <Form.Group as={Row} className="mb-3" controlId="rate">
                  <Form.Label column sm="2">Rate*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="number"
                      name="rate"
                      placeholder='Enter Rate'
                      value={formValues.rate}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Form.Group> 
              </Form>
            </Card.Body>
          </Card>
        </Modal>
      </div>
    )
  }

  export default PurchaseModal